export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  category: string;
  categorySlug: string;
  description: string;
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  tags: string[];
  chapters: ComicChapter[];
  updateDate: string;
  featured?: boolean;
  hot?: boolean;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '校园', slug: 'school', icon: 'ri-school-line', count: 128 },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 256 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 189 },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', count: 97 },
  { name: '动作', slug: 'action', icon: 'ri-sword-line', count: 143 },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 112 },
  { name: '都市', slug: 'urban', icon: 'ri-building-2-line', count: 167 },
  { name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line', count: 84 },
];

export const banners: { comicId: string; title: string; subtitle: string; coverUrl: string; tag: string }[] = [
  {
    comicId: 'comic-1',
    title: '王女降临',
    subtitle: '校园女王的热血逆袭之路，超高人气韩漫榜首之作',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20style%20illustration%20of%20a%20beautiful%20high%20school%20girl%20with%20long%20dark%20hair%2C%20elegant%20school%20uniform%2C%20confident%20expression%2C%20dramatic%20lighting%2C%20soft%20pastel%20background%20with%20cherry%20blossoms%2C%20romantic%20school%20atmosphere%2C%20clean%20art%20style%2C%20webtoon%20aesthetic&width=1400&height=600&seq=banner-01&orientation=landscape',
    tag: '热门榜首',
  },
  {
    comicId: 'comic-7',
    title: '全知读者视角',
    subtitle: '末世降临，唯有读者知晓一切，史诗级奇幻巨作',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20webtoon%20illustration%20of%20a%20young%20man%20in%20a%20post%20apocalyptic%20world%2C%20holding%20a%20glowing%20book%2C%20surrounded%20by%20floating%20text%20and%20constellations%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20lighting%20with%20blue%20and%20gold%20tones%2C%20clean%20webtoon%20style&width=1400&height=600&seq=banner-02&orientation=landscape',
    tag: '新作推荐',
  },
  {
    comicId: 'comic-4',
    title: '我独自升级',
    subtitle: '从最弱到最强，猎人之王的传奇进化之路',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20powerful%20Korean%20webtoon%20illustration%20of%20a%20shadowy%20hunter%20warrior%20with%20purple%20glowing%20eyes%2C%20surrounded%20by%20dark%20shadow%20soldiers%2C%20epic%20battle%20pose%2C%20dramatic%20dark%20atmosphere%20with%20purple%20and%20black%20color%20scheme%2C%20clean%20action%20webtoon%20style&width=1400&height=600&seq=banner-03&orientation=landscape',
    tag: '经典必看',
  },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '王女降临',
    author: 'Yaongyi',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20high%20school%20girl%20character%20portrait%20in%20webtoon%20style%2C%20long%20black%20silky%20hair%2C%20elegant%20makeup%2C%20wearing%20stylish%20school%20uniform%2C%20confident%20smile%2C%20soft%20natural%20lighting%2C%20clean%20illustration%20with%20neutral%20light%20background%2C%20romantic%20school%20drama%20aesthetic&width=400&height=560&seq=cover-01&orientation=portrait',
    category: '校园',
    categorySlug: 'school',
    description: '长相平凡的女主角通过化妆技巧华丽变身，成为校园中的风云人物。然而美丽的外表下隐藏着不为人知的秘密与伤痛，她能否在复杂的校园人际关系中找到真正的自我？一部关于成长、自信与友情的青春校园漫画。',
    rating: 9.7,
    views: 5280000,
    status: '连载中',
    tags: ['校园', '恋爱', '励志', '青春'],
    chapters: [
      { id: 'ch-1-1', title: '第1话 新生', number: 1, updateDate: '2026-08-01' },
      { id: 'ch-1-2', title: '第2话 改变', number: 2, updateDate: '2026-07-28' },
      { id: 'ch-1-3', title: '第3话 惊艳', number: 3, updateDate: '2026-07-25' },
      { id: 'ch-1-4', title: '第4话 秘密', number: 4, updateDate: '2026-07-22' },
      { id: 'ch-1-5', title: '第5话 对手', number: 5, updateDate: '2026-07-19' },
    ],
    updateDate: '2026-08-01',
    featured: true,
    hot: true,
  },
  {
    id: 'comic-2',
    title: '女神降临',
    author: '喵咪',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20college%20girl%20character%20portrait%20in%20webtoon%20style%2C%20wavy%20brown%20hair%2C%20natural%20makeup%20look%2C%20wearing%20casual%20fashionable%20clothes%2C%20gentle%20smile%2C%20soft%20warm%20lighting%2C%20clean%20illustration%20with%20neutral%20light%20background%2C%20romance%20webtoon%20aesthetic&width=400&height=560&seq=cover-02&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '因为外貌自卑的女孩通过化妆改变自己，在网络上成为万人追捧的女神。然而现实中的她依然缺乏自信，直到遇见那个看透她本质的男孩。一场关于美丽与真实、外表与内心的浪漫故事。',
    rating: 9.5,
    views: 4120000,
    status: '连载中',
    tags: ['恋爱', '校园', '励志', '化妆'],
    chapters: [
      { id: 'ch-2-1', title: '第1话 丑小鸭', number: 1, updateDate: '2026-08-02' },
      { id: 'ch-2-2', title: '第2话 变身', number: 2, updateDate: '2026-07-30' },
      { id: 'ch-2-3', title: '第3话 邂逅', number: 3, updateDate: '2026-07-27' },
      { id: 'ch-2-4', title: '第4话 心跳', number: 4, updateDate: '2026-07-24' },
    ],
    updateDate: '2026-08-02',
    hot: true,
  },
  {
    id: 'comic-3',
    title: '某天成为公主',
    author: 'Plutus',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20fantasy%20princess%20character%20portrait%20in%20webtoon%20style%2C%20blonde%20long%20hair%20with%20crown%2C%20elegant%20royal%20dress%20in%20pink%20and%20white%2C%20sparkling%20magical%20atmosphere%2C%20soft%20dreamy%20lighting%2C%20clean%20illustration%20with%20neutral%20light%20background%2C%20romantic%20fantasy%20aesthetic&width=400&height=560&seq=cover-03&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '一觉醒来变成小说中的公主，而且还是注定要被亲生父亲处死的悲剧角色！为了改变命运，她不得不努力讨好那个冷酷无情的皇帝父亲。温馨又心酸的父女亲情故事，让人笑着笑着就哭了。',
    rating: 9.6,
    views: 3890000,
    status: '连载中',
    tags: ['奇幻', '穿越', '亲情', '古风'],
    chapters: [
      { id: 'ch-3-1', title: '第1话 穿越', number: 1, updateDate: '2026-08-03' },
      { id: 'ch-3-2', title: '第2话 父皇', number: 2, updateDate: '2026-07-31' },
      { id: 'ch-3-3', title: '第3话 讨好', number: 3, updateDate: '2026-07-28' },
      { id: 'ch-3-4', title: '第4话 转机', number: 4, updateDate: '2026-07-25' },
    ],
    updateDate: '2026-08-03',
    featured: true,
  },
  {
    id: 'comic-4',
    title: '我独自升级',
    author: 'Chugong',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20cool%20Korean%20hunter%20character%20portrait%20in%20webtoon%20style%2C%20dark%20haired%20young%20man%20with%20sharp%20eyes%2C%20wearing%20black%20combat%20outfit%2C%20purple%20energy%20aura%20surrounding%2C%20dramatic%20lighting%2C%20clean%20illustration%20with%20dark%20neutral%20background%2C%20action%20fantasy%20webtoon%20aesthetic&width=400&height=560&seq=cover-04&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '被称为"人类最弱兵器"的E级猎人成振宇，在一次地下城事故中濒死，却意外获得了神秘的"系统"能力——他成为了唯一能够无限升级的猎人。从此踏上从最弱到最强的逆袭之路。',
    rating: 9.8,
    views: 6800000,
    status: '已完结',
    tags: ['动作', '奇幻', '升级', '热血'],
    chapters: [
      { id: 'ch-4-1', title: '第1话 E级猎人', number: 1, updateDate: '2026-06-15' },
      { id: 'ch-4-2', title: '第2话 系统', number: 2, updateDate: '2026-06-12' },
      { id: 'ch-4-3', title: '第3话 觉醒', number: 3, updateDate: '2026-06-09' },
      { id: 'ch-4-4', title: '第4话 地下城', number: 4, updateDate: '2026-06-06' },
      { id: 'ch-4-5', title: '第5话 升级', number: 5, updateDate: '2026-06-03' },
    ],
    updateDate: '2026-06-15',
    hot: true,
    featured: true,
  },
  {
    id: 'comic-5',
    title: '甜蜜家园',
    author: '金坎比',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20thriller%20webtoon%20character%20portrait%2C%20young%20man%20with%20haunted%20expression%2C%20dark%20circles%20under%20eyes%2C%20wearing%20torn%20clothing%2C%20dim%20apartment%20hallway%20background%2C%20horror%20atmosphere%2C%20dramatic%20shadow%20lighting%2C%20clean%20illustration%20style%2C%20psychological%20horror%20aesthetic&width=400&height=560&seq=cover-05&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    description: '隐居在破旧公寓中的少年，在末世怪物危机爆发后，与幸存的邻居们一起对抗由人类欲望化身的怪物。人性在绝境中展露无遗，恐怖的背后是对人性的深刻拷问。',
    rating: 9.4,
    views: 3450000,
    status: '已完结',
    tags: ['悬疑', '恐怖', '末世', '人性'],
    chapters: [
      { id: 'ch-5-1', title: '第1话 隐居', number: 1, updateDate: '2026-05-20' },
      { id: 'ch-5-2', title: '第2话 怪物', number: 2, updateDate: '2026-05-17' },
      { id: 'ch-5-3', title: '第3话 邻居', number: 3, updateDate: '2026-05-14' },
      { id: 'ch-5-4', title: '第4话 求生', number: 4, updateDate: '2026-05-11' },
    ],
    updateDate: '2026-05-20',
  },
  {
    id: 'comic-6',
    title: '高校之神',
    author: '朴溶济',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20action%20webtoon%20character%20portrait%2C%20young%20high%20school%20fighter%20boy%20with%20spiky%20hair%2C%20wearing%20martial%20arts%20uniform%2C%20intense%20fighting%20stance%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%20with%20motion%20effect%2C%20clean%20illustration%20with%20neutral%20background%2C%20martial%20arts%20webtoon%20aesthetic&width=400&height=560&seq=cover-06&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '全国高中生格斗大赛拉开帷幕，来自各地的武术天才齐聚一堂。主角陈毛利以他纯正的跆拳道技艺一路过关斩将，但比赛的背后隐藏着更大的阴谋。热血格斗与超能力对决的巅峰之作。',
    rating: 9.3,
    views: 2980000,
    status: '已完结',
    tags: ['动作', '格斗', '热血', '校园'],
    chapters: [
      { id: 'ch-6-1', title: '第1话 格斗大赛', number: 1, updateDate: '2026-04-10' },
      { id: 'ch-6-2', title: '第2话 跆拳道', number: 2, updateDate: '2026-04-07' },
      { id: 'ch-6-3', title: '第3话 强敌', number: 3, updateDate: '2026-04-04' },
    ],
    updateDate: '2026-04-10',
  },
  {
    id: 'comic-7',
    title: '全知读者视角',
    author: 'sing N song',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20webtoon%20character%20portrait%2C%20young%20man%20with%20glasses%20holding%20a%20glowing%20book%2C%20intelligent%20expression%2C%20wearing%20casual%20modern%20clothes%2C%20magical%20constellation%20patterns%20in%20background%2C%20mystical%20blue%20and%20gold%20lighting%2C%20clean%20illustration%20style%2C%20epic%20fantasy%20aesthetic&width=400&height=560&seq=cover-07&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '平凡上班族金独子是连载了十年网络小说《在灭亡世界生存的三种方法》的唯一读者。当小说中的末日场景在现实中真实上演时，他成为了唯一知道这个世界结局的人。',
    rating: 9.9,
    views: 7200000,
    status: '连载中',
    tags: ['奇幻', '末世', '系统', '智斗'],
    chapters: [
      { id: 'ch-7-1', title: '第1话 唯一的读者', number: 1, updateDate: '2026-08-04' },
      { id: 'ch-7-2', title: '第2话 末日降临', number: 2, updateDate: '2026-08-01' },
      { id: 'ch-7-3', title: '第3话 剧本', number: 3, updateDate: '2026-07-29' },
      { id: 'ch-7-4', title: '第4话 星流', number: 4, updateDate: '2026-07-26' },
      { id: 'ch-7-5', title: '第5话 同伴', number: 5, updateDate: '2026-07-23' },
    ],
    updateDate: '2026-08-04',
    hot: true,
    featured: true,
  },
  {
    id: 'comic-8',
    title: '她的私生活',
    author: '金成妍',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20office%20romance%20webtoon%20character%20portrait%2C%20beautiful%20professional%20woman%20with%20stylish%20bob%20haircut%2C%20wearing%20elegant%20office%20attire%2C%20holding%20a%20camera%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20illustration%20with%20light%20neutral%20background%2C%20romantic%20comedy%20aesthetic&width=400&height=560&seq=cover-08&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '美术馆策展人成德美表面上是完美的职场女性，私下却是一个狂热的偶像追星族。当新任馆长出现后，她的双重生活开始面临暴露的危机，一段啼笑皆非的办公室恋情就此展开。',
    rating: 9.2,
    views: 2150000,
    status: '已完结',
    tags: ['恋爱', '都市', '搞笑', '职场'],
    chapters: [
      { id: 'ch-8-1', title: '第1话 双重生活', number: 1, updateDate: '2026-03-15' },
      { id: 'ch-8-2', title: '第2话 新馆长', number: 2, updateDate: '2026-03-12' },
      { id: 'ch-8-3', title: '第3话 危机', number: 3, updateDate: '2026-03-09' },
    ],
    updateDate: '2026-03-15',
  },
  {
    id: 'comic-9',
    title: '极权教师',
    author: '蔡溶宅',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Korean%20dark%20school%20webtoon%20character%20portrait%2C%20intimidating%20teacher%20figure%20in%20black%20suit%2C%20cold%20expression%2C%20standing%20in%20front%20of%20classroom%20blackboard%2C%20tense%20atmosphere%2C%20dramatic%20shadow%20lighting%2C%20clean%20illustration%20style%2C%20psychological%20thriller%20aesthetic&width=400&height=560&seq=cover-09&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    description: '一位神秘的代课老师来到问题班级，用极端手段整顿校园暴力。他的教育方式残忍而高效，但背后隐藏着一个令人震惊的秘密。教育、正义与复仇交织的黑暗校园故事。',
    rating: 9.1,
    views: 1870000,
    status: '连载中',
    tags: ['悬疑', '校园', '黑暗', '复仇'],
    chapters: [
      { id: 'ch-9-1', title: '第1话 代课老师', number: 1, updateDate: '2026-08-03' },
      { id: 'ch-9-2', title: '第2话 第一课', number: 2, updateDate: '2026-07-31' },
      { id: 'ch-9-3', title: '第3话 惩戒', number: 3, updateDate: '2026-07-28' },
    ],
    updateDate: '2026-08-03',
  },
  {
    id: 'comic-10',
    title: '搞笑一家人',
    author: '李顺才',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20family%20comedy%20webtoon%20illustration%2C%20a%20chaotic%20Korean%20family%20gathered%20in%20living%20room%2C%20expressive%20funny%20faces%2C%20colorful%20casual%20clothing%2C%20warm%20homey%20atmosphere%2C%20bright%20cheerful%20lighting%2C%20clean%20illustration%20style%2C%20comedy%20webtoon%20aesthetic&width=400&height=560&seq=cover-10&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '一个普通韩国大家庭的爆笑日常生活。有固执的爷爷、唠叨的奶奶、不靠谱的爸爸、强势的妈妈，还有调皮捣蛋的孩子们。每个角色都个性鲜明，让你在捧腹大笑中感受家庭的温暖。',
    rating: 9.0,
    views: 2530000,
    status: '连载中',
    tags: ['搞笑', '家庭', '日常', '温馨'],
    chapters: [
      { id: 'ch-10-1', title: '第1话 早餐大战', number: 1, updateDate: '2026-08-04' },
      { id: 'ch-10-2', title: '第2话 遥控器之争', number: 2, updateDate: '2026-08-01' },
      { id: 'ch-10-3', title: '第3话 超市大作战', number: 3, updateDate: '2026-07-29' },
    ],
    updateDate: '2026-08-04',
    hot: true,
  },
  {
    id: 'comic-11',
    title: '金秘书为何那样',
    author: '郑景允',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20office%20romance%20webtoon%20character%20portrait%2C%20elegant%20female%20secretary%20in%20professional%20attire%2C%20confident%20expression%2C%20standing%20in%20modern%20office%20with%20city%20view%2C%20soft%20sophisticated%20lighting%2C%20clean%20illustration%20style%2C%20romantic%20drama%20aesthetic&width=400&height=560&seq=cover-11&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    description: '工作能力超群的金秘书突然提出辞职，让自恋的副会长李英俊措手不及。为了挽留这位完美秘书，他展开了一系列令人啼笑皆非的追求攻势。傲慢上司与干练秘书之间的甜蜜拉锯战。',
    rating: 9.3,
    views: 2760000,
    status: '已完结',
    tags: ['都市', '恋爱', '职场', '搞笑'],
    chapters: [
      { id: 'ch-11-1', title: '第1话 辞职信', number: 1, updateDate: '2026-02-28' },
      { id: 'ch-11-2', title: '第2话 挽留', number: 2, updateDate: '2026-02-25' },
      { id: 'ch-11-3', title: '第3话 追求', number: 3, updateDate: '2026-02-22' },
    ],
    updateDate: '2026-02-28',
  },
  {
    id: 'comic-12',
    title: '世子消失了',
    author: '慧珍',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20historical%20fantasy%20webtoon%20character%20portrait%2C%20handsome%20crown%20prince%20in%20traditional%20Korean%20hanbok%20royal%20robe%2C%20mysterious%20expression%2C%20ancient%20palace%20background%20with%20moonlight%2C%20soft%20mystical%20lighting%2C%20clean%20illustration%20style%2C%20historical%20romance%20aesthetic&width=400&height=560&seq=cover-12&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    description: '朝鲜王朝的世子突然神秘消失，朝野震动。一位现代少女意外穿越到古代，竟与失踪的世子产生了奇妙的联系。宫廷阴谋与跨越时空的爱恋，古代韩服之美尽在其中。',
    rating: 9.5,
    views: 1980000,
    status: '连载中',
    tags: ['古风', '穿越', '恋爱', '宫廷'],
    chapters: [
      { id: 'ch-12-1', title: '第1话 失踪', number: 1, updateDate: '2026-08-02' },
      { id: 'ch-12-2', title: '第2话 穿越', number: 2, updateDate: '2026-07-30' },
      { id: 'ch-12-3', title: '第3话 相遇', number: 3, updateDate: '2026-07-27' },
    ],
    updateDate: '2026-08-02',
  },
];

export const latestUpdates: Comic[] = [...comics].sort(
  (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
).slice(0, 8);

export const hotComics: Comic[] = comics.filter((c) => c.hot);

export const featuredComics: Comic[] = comics.filter((c) => c.featured);

export const getComicsByCategory = (slug: string): Comic[] =>
  comics.filter((c) => c.categorySlug === slug);

export const getComicById = (id: string): Comic | undefined =>
  comics.find((c) => c.id === id);

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);